import React, { useState, useEffect } from "react";
import { CarouselProps } from "../../Interfaces/Interfaces";


const Carousel: React.FC<CarouselProps> = ({ images }) => {
  

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((currentIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(intervalId);
  }, [currentIndex, images.length]);

  return (
    <div className="">
      <img src={images[currentIndex]} alt='imgs not found' />
    </div>
  );
};

export default Carousel;